import React from "react"
import { Col, Card, CardBody } from "reactstrap"

// Card de resumo (mini-stats) clicável da ListaOS.
// Antes eram 4 blocos idênticos; agora um componente apresentacional.
// `ativo` aplica a borda de destaque; `onClick` mantém o comportamento de
// cada card (filtrar por status ou limpar o filtro).
const MiniStatsCard = ({ ativo, onClick, title, label, count, icon }) => (
  <Col xs={6} md={3}>
    <Card
      className={`mini-stats-wid ${ativo ? "border border-primary" : ""}`}
      style={{ cursor: "pointer" }}
      onClick={onClick}
      title={title}
    >
      <CardBody>
        <div className="d-flex flex-wrap">
          <div className="me-3">
            <p className="text-muted mb-2">{label}</p>
            <h5 className="mb-0">{count}</h5>
          </div>
          <div className="avatar-sm ms-auto">
            <div className="avatar-title bg-light rounded-circle text-primary font-size-20">
              <i className={icon}></i>
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  </Col>
)

export default MiniStatsCard
